module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-return-left-c97b32a2.svg";